import React from "react";
import LifestyleThreeZoneTrendChart, {
  type SleepChartDataPoint,
  getSleepColor,
} from "../../../HealthChart/components/LifestyleThreeZoneTrendChart";

export type { SleepChartDataPoint };
export { getSleepColor };

export interface SleepChartProps {
  data: SleepChartDataPoint[];
}

const SleepChart: React.FC<SleepChartProps> = ({ data }) => (
  <LifestyleThreeZoneTrendChart variant="sleep" data={data} />
);

export default SleepChart;
